import React, { useEffect, useState } from "react";
import orangeTop from "../../assets/images/png/orange_top_vector.png";
import tamplegreat from "../../assets/images/the-great-souls/png/temple_the_great_souls.png";
import bottomFlower from "../../assets/images/svg/bottom_flower.svg";
import topFlower from "../../assets/images/svg/top_flower.svg";
import buttonYellowLeft from "../../assets/images/svg/button-yellow-left-layer.svg";
import buttonYellowRight from "../../assets/images/svg/button-yellow-right-layer.svg";
import { scaredList, ModalList } from "../../utils/ScaredPlacesHelper";
import Modal from "../common/modal/Modal";
const ScaredPlaces = () => {
  const [popupOpen, setPopupOpen] = useState(null);

  function showPopup(index) {
    setPopupOpen(popupOpen === index ? null : index);
  }

  const isModalOpen = popupOpen !== null;
  useEffect(() => {
    if (isModalOpen) {
      document.getElementById("html").classList.add("overflow-hidden");
    } else {
      document.getElementById("html").classList.remove("overflow-hidden");
    }
    // Cleanup on component unmount
    return () => {
      document.getElementById("html").classList.remove("overflow-hidden");
    };
  }, [isModalOpen]);
  return (
    <>
      <div className="position-relative" id="about-us">
        {/* <img
          className="position-absolute end-0 w-100 common_orange_bottom_layer_top"
          src={orangeTop}
          alt="vector"
        /> */}
        {/*<img
          className="position-absolute bottom_flower_mahamantra_three end-0"
          src={bottomFlower}
          alt="no"
  />*/}
        <img
          src={tamplegreat}
          className="w-25 position-absolute start-0"
          style={{ bottom: "-10%" }}
          alt="#"
        />
        {/*<img
          className="position-absolute top_flower_mahamantra souls_top_flower start-0"
          src={topFlower}
          alt="no"
      />*/}
        <div className="container_modified container position-relative z-3 mt-4 mt-md-5 ">
          <div className="row justify-content-center mt-xl-2 pt-4 pt-md-0">
            <div className="col-lg-10 px-3 text-center mb-4 pb-lg-4">
              <h3 className="text-orange text-uppercase common_heading_text common_heading_text_brown">
                THE SACRED PLACES
              </h3>
              <h2 className="common_sub_heading text-center mb-3">
                Welcome to Girnar Sadhana Ashram
              </h2>
              <p className="common_para mb-2 lh_25">
                On the banks of the Ganga in Rishikesh, the ancient dwelling place of the Vedic Rishis. For untold centuries, those wishing for true happiness for
                themselves and others have chosen to do their meditations, retreats, austerities and yogic practices in forests, caves and
                high mountains - in places hidden away from the world. There, the profound harmonics of power and accomplishment have gathered
                and to some extent remained. Rishikesh is one such notable place aided by the River Ganges who contributes her blessings to all
                who are open to her ten-thousand purposes. While our modern-day abilities to travel and 'get away' are easily available, still it is most beneficial - especially at
                first, when receiving something profound that has the ability not only to boost your spiritual energy but also to befriend you
                for the rest of your life - to retreat to a place that supports the depth and potency of your inner longings.
              </p>
            </div>
          </div>
          <div className="row justify-content-center mb-4 pb-4">
            {scaredList.map((obj, index) => {
              return (
                <div
                  className={`col-md-6 col-lg-4 ${obj.customClass}`}
                  key={index}
                >
                  <div
                    className="position-relative text-center  cursor_pointer "
                    onClick={() => showPopup(index)}
                  >
                    <div className="position-relative">
                      <div className="position-absolute w-100 d-flex justify-content-center bottom-0 pb-4 mb-3">
                        <div className="position-relative z-3 w_fit_content mx-auto">
                          <img
                            className="position-absolute name_lable_image navbar_left_vector z_index_1 start-0"
                            src={buttonYellowLeft}
                            alt="vector"
                          />
                          <img
                            className="position-absolute name_lable_image navbar_right_vector z_index_1 end-0"
                            src={buttonYellowRight}
                            alt="vector"
                          />
                          <button className="name_lable fs_sm_14">
                            {obj.title}
                          </button>
                        </div>
                      </div>
                      <img
                        src={obj.image}
                        className="w-100 max_sm_w common_card_hov transition_03"
                        alt="soul"
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          className="nav_overlay position-fixed top-0 start-0 vh-100 w-100"
          onClick={() => setPopupOpen(null)}
        ></div>
      )}
      {isModalOpen && (
        <Modal
          data={ModalList[popupOpen]}
          showPopup={() => setPopupOpen(null)}
        />
      )}
    </>
  );
};

export default ScaredPlaces;
